import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as PlaySvg } from './assets/play.svg';

const PlayIcon = React.forwardRef((args, ref) => <SvgIcon component={PlaySvg} ref={ref} {...args} />);

export default PlayIcon;
